export default "__VITE_ASSET__Cdg5VSPO__"